import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { Loading } from "@/components/Page/Loading";

export const AuthActionPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const mode = searchParams.get("mode");

  console.log(mode);

  useEffect(() => {
    if (!mode) return;
    switch (mode) {
      case "verifyEmail":
        navigate({ pathname: "/verify", search: searchParams.toString() });
        break;
      case "resetPassword":
        navigate({
          pathname: "/resetPassword",
          search: searchParams.toString(),
        });
        break;
      case "recoverEmail":
        navigate({
          pathname: "/recoverEmail",
          search: searchParams.toString(),
        });
        break;
      default:
        break;
    }
  }, [mode, navigate, searchParams]);

  return <Loading />;
};
